import { Typography } from "antd";

const TabSelector = ({ activeTab, setActiveTab, jaula, darkMode }) => {
  return (
    <div
      className="ubi-wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "flex-start",
        alignItems: "stretch",
        padding: "8px 16px",
        height: "auto",
        minHeight: 80,
      }}
    >
      <div style={{ display: "flex", gap: 10 }}>
        <div
          onClick={() => setActiveTab("todos")}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "6px 0",
            backgroundColor: activeTab === "todos" ? "#1890ff" : "#afadadff",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          <Typography.Text
            strong
            style={{
              color: activeTab === "todos" ? "#fff" : "inherit",
            }}
          >
            Todos
          </Typography.Text>
        </div>
        <div
          onClick={() => setActiveTab("granel")}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "6px 0",
            backgroundColor: activeTab === "granel" ? "#1890ff" : "#afadadff",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          <Typography.Text
            strong
            style={{
              color: activeTab === "granel" ? "#fff" : "inherit",
            }}
          >
            Granel
          </Typography.Text>
        </div>
        <div
          onClick={() => setActiveTab("palet")}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "6px 0",
            backgroundColor: activeTab === "palet" ? "#1890ff" : "#afadadff",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          <Typography.Text
            strong
            style={{
              color: activeTab === "palet" ? "#fff" : "inherit",
            }}
          >
            Palet
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default TabSelector;
